(function () {
  class SlCampaignBundles extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.boundClick = this.onClick.bind(this);
      this.slider = this.querySelector('[data-sl-bundle-slider]');
      this.nextButton = this.querySelector('[data-sl-bundle-next]');
      this.prevButton = this.querySelector('[data-sl-bundle-prev]');
      this.progressFill = this.querySelector('[data-sl-bundle-progress-fill]');
      this.boundUpdateProgress = this.updateProgress.bind(this);

      this.addEventListener('click', this.boundClick);
      this.initSwiper();
      window.addEventListener('resize', this.boundUpdateProgress);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundClick);
      window.removeEventListener('resize', this.boundUpdateProgress);
      this.swiper?.destroy?.(true, true);
    }

    initSwiper() {
      if (!this.slider || typeof window.Swiper === 'undefined') return;

      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 600,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation:
          this.nextButton && this.prevButton
            ? {
                nextEl: this.nextButton,
                prevEl: this.prevButton,
              }
            : false,
        breakpoints: {
          768: {
            spaceBetween: 16,
          },
          1200: {
            spaceBetween: 18,
          },
        },
        on: {
          init: () => this.updateProgress(),
          resize: () => this.updateProgress(),
          setTranslate: () => this.updateProgress(),
          transitionEnd: () => this.updateProgress(),
          slideChange: () => this.updateProgress(),
        },
      });
    }

    onClick(event) {
      const button = event.target.closest('[data-sl-bundle-add]');
      if (!button || !this.contains(button)) return;

      event.preventDefault();
      this.addBundle(button, button.hasAttribute('data-sl-bundle-checkout'));
    }

    async addBundle(button, shouldCheckout) {
      const card = button.closest('.sl-bundle-card');
      const variantIds = (button.dataset.variantIds || '').split(',').filter(Boolean);
      const quantities = (button.dataset.quantities || '').split(',').map((value) => Number(value || 1));
      const root = window.Shopify?.routes?.root || '/';

      if (!variantIds.length) {
        this.setMessage(card, 'Please select available products.', true);
        return;
      }

      const items = variantIds.map((id, index) => ({
        id: Number(id),
        quantity: Math.max(1, quantities[index] || 1),
      }));

      this.setLoading(button, true);
      this.setMessage(card, '');

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });
        const payload = await response.json();

        if (!response.ok) {
          throw new Error(payload?.description || payload?.message || 'Unable to add this bundle.');
        }

        if (shouldCheckout) {
          window.location.href = `${root}checkout`;
          return;
        }

        await this.refreshCart(payload);
        this.setMessage(card, 'Bundle added.');
      } catch (error) {
        this.setMessage(card, error.message || 'Unable to add this bundle.', true);
      } finally {
        this.setLoading(button, false);
      }
    }

    async refreshCart(payload) {
      const root = window.Shopify?.routes?.root || '/';
      const cartDrawer = document.querySelector('m-cart-drawer');

      if (cartDrawer?.onCartDrawerUpdate) {
        cartDrawer.onCartDrawerUpdate();
        window.setTimeout(() => cartDrawer.open?.(), 150);
      }

      if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
        try {
          const cart = await fetch(`${root}cart.js`).then((response) => response.json());
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {
            ...cart,
            source: 'sl-campaign-bundles',
          });
        } catch (error) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {
            ...payload,
            source: 'sl-campaign-bundles',
          });
        }
      }
    }

    setLoading(button, isLoading) {
      button.classList.toggle('is-loading', isLoading);
      button.disabled = isLoading;
    }

    setMessage(card, message, isError = false) {
      const messageNode = card?.querySelector('[data-sl-bundle-message]');
      if (!messageNode) return;

      messageNode.textContent = message;
      messageNode.classList.toggle('is-error', isError);
    }

    updateProgress() {
      const track = this.querySelector('.sl-campaign-bundles__progress');
      if (!this.progressFill || !track || !this.swiper) return;

      const snapCount = this.swiper.snapGrid?.length || 0;
      if (snapCount <= 1) {
        this.progressFill.style.width = '100%';
        this.progressFill.style.transform = 'translateX(0px)';
        return;
      }

      const visibleRatio = Math.min(1, this.swiper.width / this.swiper.virtualSize);
      const trackWidth = track.clientWidth || 100;
      const thumbWidthPx = Math.max(24, visibleRatio * trackWidth);
      const minTranslate = this.swiper.minTranslate ? this.swiper.minTranslate() : 0;
      const maxTranslate = this.swiper.maxTranslate ? this.swiper.maxTranslate() : 0;
      const translateRange = minTranslate - maxTranslate;
      let progress = 0;

      if (translateRange > 0) {
        progress = (minTranslate - this.swiper.translate) / translateRange;
      }

      progress = Math.min(1, Math.max(0, progress));
      const travelPx = Math.max(0, trackWidth - thumbWidthPx);

      this.progressFill.style.width = `${thumbWidthPx}px`;
      this.progressFill.style.transform = `translateX(${travelPx * progress}px)`;
    }
  }

  if (!customElements.get('sl-campaign-bundles')) {
    customElements.define('sl-campaign-bundles', SlCampaignBundles);
  }
})();
